export default __webpack_public_path__ + "static/media/Account_orange.8a88c977.svg";